<template>
    <div id="wrapper" class="position-relative w-100 overflow-hidden">
		<main id="main" class="py-60">
			<div class="container">
				<div class="box-shadow pt-77 pb-162">
					<div class="row justify-content-center">
						<div class="col-10">
							<h2 class="text-center mb-50">Step 1<span class="text-light-blue d-block">What type of flight?</span></h2>
							<div class="inner-container">
								<div class="row">
									<div class="col-md-6 mb-20">
										<button class="btn btn-light-blue position-relative w-100 py-15 mb-15" type="button" @click="goToPlannedTrip" >Planned Flight
										</button>
										<div class="font-14">
											I have booked this flight with a Broker/Operator and want to find someone to share it.
										</div>
									</div>
									<div class="col-md-6  mb-20">
										<button class="btn btn-primary position-relative w-100 py-15 mb-15" type="button" @click="goToProposedTrip">Proposed Flight
                    </button>
										<div class="font-14">
                      My flight is not confirmed. When I find someone to share it, SharedCharter's Concierge will help us book the flight.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>

export default {
	methods: {
		goToPlannedTrip() {
			this.$router.replace('/trip/create/planned');
		},
		goToProposedTrip() {
			this.$router.replace('/trip/create/proposed');
		}
	}
}
</script>